import { useState, useEffect } from 'react';
function getWindowWidth() {
    const width = window.innerWidth;
    return width;
}
const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(getWindowWidth());
    useEffect(() => {
        function handleResize() {
            setWindowWidth(getWindowWidth);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowWidth;
};
export default useWindowWidth;
